module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-23"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _vm._v("he didn’t want to wake her babies.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Stepping into the bedroom she had turned into a beautiful, fairy-tale-like nursery, the short, maternal-looking woman eased the door closed behind her, careful not to make a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her deep-set brown eyes swept over all three of the delicate, snow-white, Angelina Six Leg cribs in the room, each placed against a different wall so that she had room to move around, room to scoop up whichever infant needed her at the moment. The cribs, with their hand-carved headboards were identical and very expensive, but nothing was too good for her babies.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tiptoeing over to the first crib, she looked down at Adele and smiled. Her eyes were closed. She was still asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Unable to resist, Tessie placed her hand ever so lightly on the small tummy, barely making contact. Even so, she could feel Adele breathing. The simple up and down movement filled her with a sense of awe as well as joy. Adele had been her first.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You go on sleeping, sweetheart,” Tessie whispered softly, “so you can grow up big and strong. Mama loves you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The heavyset woman then made her way to the next crib.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maureen appeared to be fast asleep, as well. Even so, when Tessie gently brushed her fingertips along the infant’s smooth, silky cheek, she saw the tiny rosebud mouth begin to root around, as if she was searching for her bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This one was going to wake up hungry, Tessie thought, lingering over the crib.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d better get your bottle ready, little one,” she murmured softly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As Tessie drew her hand back, she accidentally brushed it against Maureen’s tightly closed fist. Even in sleep, the infant reacted. Her fingers closed around Tessie’s finger, creating a link—a brand-new life connecting to one that had been around for more than five decades.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tessie stood over the crib for several moments, absorbing the warm sensations she always felt whenever Maureen would grasp her finger this way.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The helplessness of the infant before her branded her heart. Maureen was completely dependent on her for everything, as were Adele and the occupant of the third crib, Cathy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sense of responsibility she was feeling humbled Tessie, the way it always did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Disengaging her finger from Maureen’s grasp, Tessie made her way over to the third crib a little more slowly. There was rain in the air, and that always seemed to bother her arthritic knees.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cathy was her favorite, although she would never allow the other two to suspect this. She knew she wasn’t supposed to have favorites, but she couldn’t help herself. Whenever she approached and touched Cathy, the infant would turn her head to look at her, as if Cathy had recognized her from the very first.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It felt as if they had bonded the second Cathy had come into her life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tessie had thought perhaps this was all just a happy coincidence, Cathy turning her head and making eye contact when she touched the baby, but it wasn’t. Cathy actually responded to her, would look to find her no matter which side of the crib she stood on. Those electric-blue eyes would always seek her out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well hello, Night Owl,” Tessie cooed over the infant. “I see you’re still awake.” Tessie chuckled. “Somehow, I knew you would be. Tell you what, what do you say to letting your sisters stay in dreamland while just the two of us go off? You and I have a date with a warm bottle and a rocking chair.” Tessie smiled at the small figure in the large crib. “There might even be a lullaby in it for you if you don’t make a sound to wake your sisters.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bending over the crib, the woman placed her hands carefully beneath the precious bundle and silently lifted her into her arms. Cathy turned her head as if to watch her and make sure that everything was all right.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Placing the baby against her shoulder, Tessie could feel the infant’s weight shifting, could feel her tiny body melding against her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She never grew tired of that sensation. It filled her with love and the desire to protect these tiny little beings with the last ounce of breath in her body.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She patted Cathy’s back as she withdrew from the room. Cathy didn’t make a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good girl,” Tessie whispered. “You didn’t wake your sisters.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Leaving the room as softly as she had entered, Tessie closed the door again so that no outside noises could rouse either Adele or Maureen. After all, she only had two hands, and one baby at a time was really all she could handle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Despite the fact that the door to the nursery was closed, Tessie still kept her voice to a whisper. “I don’t know where your bottle got to, so I’m using Maureen’s. I won’t tell if you don’t,” she said to the infant, chuckling.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cathy remained silent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tessie’s smile spread. “I’ll take that as a yes,” she said, pleased. “When the new little one comes,” she continued as she walked through the house to get to the kitchen, “I’m going to be counting on you to show her the ropes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not making a sound, Cathy continued to look at her, appearing to hang on every word that was said.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-17"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143cd8bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 78
// module chunks = 0